




import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ImageKinds, ImageSourceKinds } from "../../../../domain/document";
import { IImageDrawable } from "../../../../domain/document/items";
import { EditingDocument } from "..";
import { ProRadDrawExecuteResult, ProRadDrawExecuteRequest, ProRadDrawImageResult } from "../../../../domain/localhost/items";
import { ApplicationDialogsAccessor } from "../CommonComponentsAccessor";
import { Dictionary } from "../../../../domain/system";

@Component
export default class ProRadDrawAdapter extends Mixins() {
  @Prop()
  source: EditingDocument;

  @Prop()
  dialogs: ApplicationDialogsAccessor;

  isContentEditable(source: IImageDrawable): boolean {
    return source.claioImageId
        && (0 <= [ImageKinds.ClaioImage].indexOf(source.imageKind));
  }

  async editContents(source: IImageDrawable[]): Promise<ProRadDrawExecuteResult> {
    try {
      const result = await this.dialogs.launcher.show(
        null,
        this.editParameters,
        this.toEditProRadDrawRequest(source)
      );
      this.$logger.debug(result);
      if (!result || !result.images || !Enumerable.from(result.images as ProRadDrawImageResult[]).any(i => !!i.imageSource)) {
        this.$logger.warn("画像編集処理がキャンセルされました。");
        return null;
      }
      if (!(result instanceof ProRadDrawExecuteResult) || !result.isComplete) {
        throw new Error("画像編集の処理を完了できませんでした。");
      }
      return result;
    } catch (e) {
      this.$error("Claio画像編集起動失敗", "画像編集処理が完了できませんでした。", e);
      return null;
    }
  }

  private toEditProRadDrawRequest(source: IImageDrawable[]): ProRadDrawExecuteRequest {
    return {
      images: Enumerable.from(source).select(i => {
        return {
          originalImageSourceUrl: this.getOriginalImageSourceUrl(i),
          originalImageGuid: this.getOriginalImageSourceUrl(i) ? i.originalImageSource.imageGuid : null,
          currentImageSourceUrl: i.imageSource.source,
          currentImageGuid: i.imageSource.imageGuid,
        };
      }).toArray()
    };
  }

  private getOriginalImageSourceUrl(source: IImageDrawable): string {
    return (source.originalImageSource && source.originalImageSource.imageSourceKind !== ImageSourceKinds.None)
      ? source.originalImageSource.source
      : null;
  }

  get editParameters(): Dictionary<string, string> {
    const dictionary = new Dictionary<string, string>();
    dictionary.set("action", "proRadDraw");
    return dictionary;
  }
}
